import { constraints, extensions, hdrm, view, blocks } from '@yola/ws-sdk';
import isCustomBlock from '../../blocks/verifiers/is-custom-block';
import getCaptionForElement from '../../common/helpers/get-caption-for-element';
import getRootBlockByElement from '../../blocks/helpers/get-root-block-by-element';

const { controlTypes } = extensions;

const elementsToSkip = ['ws-button'];

const getElementAncestorChain = (element) => {
  const chain = [];
  let current = element;

  const rootBlock = getRootBlockByElement(element);

  if (!isCustomBlock(rootBlock)) {
    return chain;
  }

  while (current) {
    if (isCustomBlock(current)) break;

    if (!current.matches(elementsToSkip.join(','))) {
      const matchedConstraints = constraints.filters.findAllFor(current);
      const hasExtensionControls =
        extensions.filters.findControlsFor(current, controlTypes.ELEMENT).length > 0;

      if (!!matchedConstraints.length || hasExtensionControls) {
        const { label } = getCaptionForElement(current);
        const elementId = view.accessors.getLiveElementId(current);

        if (label) {
          chain.push({ elementId, label });
        }
      }
    }

    const parentRefId = hdrm.instance.driver.referenceMap.getParentReferenceId(current);
    current = parentRefId ? hdrm.accessors.getLiveElement(parentRefId) : null;
  }

  return chain;
};

export default getElementAncestorChain;
